
























































































































import {
  TableHeader,
  Params,
  VueTable,
  Paginator,
  Iterable,
} from '@/utils/interfaces'
import { tableHandler } from '@/utils/mixins/tableHandler'
import { Provider, GetProviderDTO } from '@/utils/interfaces/topup.interface'
import ActionButton from '@/components/ActionButton.vue'
import ProviderCredit from '@/components/Services/TopUps/ProviderCredit.vue'
import Autocomplete from '@/components/Autocomplete.vue'
import { getAgencies } from '@/api/Agency/agency.api'
import AddProviderCredit from '@/components/Services/TopUps/AddProviderCredit.vue'
import { AxiosResponse } from 'axios'
import { getAgencyProviders, getAgencySharedProviders } from '@/utils/functions'
import ShareProviderDialog from '@/components/Services/TopUps/Providers/ShareProviderDialog.vue'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'

export default tableHandler<Provider>().extend({
  components: {
    appActionButton: ActionButton,
    appProviderCredit: ProviderCredit,
    appAutocomplete: Autocomplete,
    appAddProviderCredit: AddProviderCredit,
    appShareProviderDialog: ShareProviderDialog,
    FlatCard,
    TextButton,
  },
  data() {
    return {
      tabs: 0,
      agency: this.$store.getters.agency.uuid,
      getAgencies: getAgencies,
      setupItem: {} as {} | Provider,
      settingsDialog: false,
      addItem: null as null | Provider,
      addDialog: false,
      loading: false,
      multiplication: 1,
      items: [] as GetProviderDTO[],
      sharedItems: [] as GetProviderDTO[],
      search: '',
    }
  },
  computed: {
    computedItems(): GetProviderDTO[] {
      const criteria = this.search?.toLowerCase() || ''

      const filter = (
        item: GetProviderDTO & { agency_name?: string; credit?: string },
      ) =>
        (item.provider_credit || item.credit)?.toString().includes(criteria) ||
        item.name.toLowerCase().includes(criteria) ||
        item.agency_name?.toLowerCase().includes(criteria)

      if (this.tabs === 1) {
        return this.sharedItems.filter(filter)
      }
      return this.items.filter(filter)
    },
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
    shared(): boolean {
      return !!this.tabs
    },
    getter(): (
      params?: Params,
    ) => Promise<AxiosResponse<Paginator<GetProviderDTO>>> {
      if (this.tabs === 1) {
        return (params?: Params) => getAgencySharedProviders({ ...params })
      } else
        return (params?: Params) =>
          getAgencyProviders({ ...params, agency__uuid: this.agency })
    },
    table(): VueTable {
      const tables = this.$refs.table as VueTable[]
      if (tables && tables[this.tabs]) {
        return tables[this.tabs]
      } else return {} as VueTable
    },
    computedHeaders(): TableHeader[] {
      if (this.shared) {
        const headers = [
          {
            text: this.$t('name'),
            value: 'name',
          },
          {
            text: this.$t('agency.agency'),
            value: 'agency_name',
          },
          {
            text: this.$t('credit') + '($)',
            value: 'provider_credit',
          },
          {
            text: this.$t('edit'),
            value: 'actions',
          },
        ] as TableHeader[]
        return headers
      } else
        return [
          {
            text: this.$t('name'),
            value: 'name',
          },
          {
            text: this.$t('description'),
            value: 'description',
          },
          {
            text: this.$t('credit') + '($)',
            value: 'provider_credit',
          },
          {
            text: this.$t('real-credit') + ' ($)',
            value: 'provider_real_credit',
          },
          {
            text: this.$t('edit'),
            value: 'actions',
          },
        ]
    },
  },
  methods: {
    onNew(item: GetProviderDTO) {
      this.computedItems.push(item)
    },
    onCreditSuccess(value: number) {
      if (this.addItem) {
        let field = 'provider_credit'
        if (this.shared) {
          field = 'credit'
        }
        ;(this.addItem as Iterable)[field] = (
          Number((this.addItem as Iterable)[field]) + Number(value)
        ).toString()
      }
    },
    onAddCredit(item: Provider) {
      this.addItem = item
      this.addDialog = true
      this.multiplication = 1
    },
    onSubstractCredit(item: Provider) {
      this.addItem = item
      this.addDialog = true
      this.multiplication = -1
    },
    refresh() {
      this.getItems()
    },
    async getItems() {
      try {
        this.loading = true
        const response = await this.getter({ limit: 100 })
        if (this.tabs === 1) {
          console.log(response.data.results)
          this.sharedItems = response.data.results
        } else {
          this.items = response.data.results
        }
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    agency() {
      this.getItems()
    },
  },
  mounted() {
    getAgencySharedProviders({ limit: 500 }).then(response => {
      this.sharedItems = response.data.results
    })

    getAgencyProviders({ limit: 500, agency__uuid: this.agency }).then(
      response => {
        this.items = response.data.results
      },
    )
  },
})
